<template>
	<div class="note-btn-group">
		<card type="cinc" class="ReClientNote lightTheme" :class="chatStyle" v-if="!bIsDelited"> 
			<template v-slot:header>
			<div>
				<div class="row align-items-center">
					<div class="col">
						<span class="badge badge-pill badge-success mr-1" v-if="isShownInTicket && objNote.NoteType != 'message' && isShownInLead && objNote.title != ''">Заметка</span>
						<span class="badge badge-pill badge-success mr-1" v-if="objNote.NoteType == 'message'">мессенджер</span>
						<span class="badge badge-pill badge-warning mr-1" v-if="objNote.title == '' && isShownInLead">Изменения</span>
						<!--span class="badge badge-pill badge-grey ml-2">Архив</span-->
						<!-- <span v-if="objNote.title !='' && objNote.title != null">{{objNote.title}}</span> -->
						<div class="date note-title">
							<span >{{objNote.agent_name}}</span>
							<span v-if="objNote.NoteType == 'message'">{{objNote.staff_name}}</span>
							<span class="ml-2" v-if="objNote.InsTime">{{$GVO.convertDateTimeFromMysql(objNote.InsTime)}}</span>
							<span class="ml-2" v-if="objNote.InsertTime">{{$GVO.convertDateTimeFromMysql(objNote.InsertTime)}}</span>
							
						</div>
					</div>

					<!--div class="btn-row pr-2" v-if="isShownInTicket && objNote.NoteType != 'message' && !isShownInLead"-->
					<div class="btn-row pr-2" v-if="CheckAcc(objNote)">
						<base-button v-if="$GVO.my_profile.adm == 1"  @click="GoToHistory()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-ic ic-history"></i></base-button>
						<base-button  @click="GoToEdit()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-pencil"></i></base-button>
						<base-button  @click="delNote()" type="danger" class="no-border" simple icon><i class="d-inline-block tim-icons icon-trash-simple"></i></base-button>
					</div>
				</div>
			</div>
			</template>

			<div class="note-content">
				
				<template v-if="!bIsEdit">
					<div class="d-flex flex-wrap mt-2">
					<p v-if="objNote.title !='' && objNote.title != null && isShownInTicket" class="mr-2 text-primary"> {{objNote.title}}</p>
					<ReNoteJson v-if="objNote.NoteType=='json_message'" :data="objNote.descr"></ReNoteJson>
					<p v-else class=" note-text" v-html="$GVO.parseLink(objNote.descr)"></p>
					</div>
				</template>
				<pre v-if="strHist!=''">
				    {{ strHist }}	
				</pre>							
				<form v-if="bIsEdit" class="form-container">
					<div class="top_part">           
						<textarea 
							class="form-control"
							placeholder="Текст"
							ref="saveInput"						
							v-model="strNote">	
						</textarea>	
						
						
						
						
					</div>
					<div class="bottom_part mt-2 pb-1">
						<base-button type="success" simple icon @click="UpdNote()" class="mr-0"><i class="d-inline-block tim-icons icon-send"></i></base-button>
					</div>
				</form>
			</div>  
			<div class="note-docs" v-if="objNote.atach_arr !='' && objNote.atach_arr != null"> 
				
				<div v-if="objNote.atach_arr.fullpath.toLowerCase().includes('.jpg') || objNote.atach_arr.fullpath.toLowerCase().includes('.jpeg') || objNote.atach_arr.fullpath.toLowerCase().includes('.png')" 
				class="itemPhoto mr-2 lenta-photo">
				    <a :href="objNote.atach_arr.fullpath" target="_blank"><img  :src="objNote.atach_arr.fullpath"/></a>
				</div>
				<div v-else-if="objNote.atach_arr.fullpath.toLowerCase().includes('.mp3') || objNote.atach_arr.fullpath.toLowerCase().includes('.wav')">
				    <audio controls :src="objNote.atach_arr.fullpath"></audio>
				</div>
				<!--
				<div v-else-if="this.isShownInTicket == false">
					<img  class="ticketphoto" :src="objNote.atach_arr.fullpath" alt="">
				</div>					
				-->
				<!-- <div v-else-if="this.isShownInTicket == true" > -->
				<div v-else>
					<i class="d-inline-block tim-icons icon-paper text-primary mr-2"></i>
					<a :href="objNote.atach_arr.fullpath" target="_blank">
						{{objNote.atach_arr.src_filename}}
					</a>
				</div>	
			</div>
			<template v-if="!bIsEdit && isShownInTicket">
				<div class="date mt-2" v-if="objNote.UpdTime != objNote.InsTime"><span class="d-flex justify-content-end">Ред.: {{$GVO.convertDateTimeFromMysql(objNote.UpdTime)}}</span></div>
			</template>
		</card>
	</div>
</template>

<script>
// import ReFileUpload from "src/our_components/ReFileUpload.vue";
import ReNoteJson from "./ReNoteJson.vue";

export default {
	name: 'ReClientNote',
	components: {
		// ReFileUpload,
		ReNoteJson,
	},
	props: {
		counter: String,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',            
		},
		objNote: {
			type: Object,
			default: function() {
				return {};
			}
		},
		chatStyle: { 
			type: String,
			default: 'StylesDefault',            
		},
	},
	data () {
		return {
			ver: 1, 
			bIsDelited: false,           
			bIsEdit: false,
			strNote: '',
			isShownInTicket: true,
			isShownInLead:true,
			strHist: '',
		}
	},
	computed: {
		dt_update(){
			return this.objNote.UpdTime;
		}
	},
	methods: {     
		
		delNote() {
			this.$GVO.ApiCall('DEL', {obj:'NOTES', flt:{id: this.objNote.id}})
			.then((objApi) => {
				//console.log(objApi.data);
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.masLenta = objApi.data;
						
					} this.bIsDelited = true;				
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		GoToEdit(){
			this.strNote = this.objNote.descr;
			this.bIsEdit = true;
		},
		UpdNote(){	
			this.$GVO.ApiCall('UPD',{obj:'NOTES',flt:{'id': this.objNote.id},uData:{'descr':this.strNote}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success === true){
					this.bIsEdit = false;
					this.strNote = '';
					this.$emit('onUpdate', true);
				} 						
			}).catch(errorObjApi => console.error(errorObjApi));		
		},
		CheckAcc(N_DATA){
		    if(this.$GVO.my_profile.adm == 1){ return true;}
		    if(this.$GVO.my_profile.code == N_DATA.agent_id){ return true;}
		    return false;
		},
		GoToHistory(){
			this.$GVO.ApiCall('GET_HISTORY',{obj:'NOTES',flt:{'id': this.objNote.id}})
			.then((objApi) => {
				// console.log(objApi);
				if(objApi.success === true){
				    this.strHist = objApi.data;
				} 
			}).catch(errorObjApi => console.error(errorObjApi));				
		}
	},
	created(){
		if(location.pathname.indexOf('/data/ticketsystem/id') != -1){this.isShownInTicket = false;} else {this.isShownInTicket = true;}
		// if(location.pathname.indexOf('/data/callcenter/id') != -1){this.isShownInLead = true;} else {this.isShownInTicket = false;}
	}
}
</script>
<style scoped>
.ReClientNote {border: 1px solid rgba(1, 176, 224, 0.4);}
.ReClientNote .date {
	font-size: 12px;
	/* color: #9A9A9A; */
	margin-top: 5px;
}
.ReClientNote >>> .card-body {padding: 0px 15px 15px 15px; }
.badge-grey {background: #9A9A9A; color: #fff;}
.white-content .card:not(.card-white) .lightTheme {border: 1px solid #c4c4c4; }
.call-audio {
    background-color: transparent;
    border: 1px solid #01B0E0;
    box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.note-text {word-break: break-word;}
.StylesAuthor {border: 1px solid #00BF9A; background-color: #183d63;}
.white-content .card:not(.card-white) .StylesAuthor {background-color: #ebf3fb!important;} 
.StylesRandom {border: 1px solid #9e77f3;}
.white-content .card:not(.card-white) .StylesDefault {background: #f1f6fc!important; border: 1px solid #c4c4c4;}
.ticketphoto {max-width: 600px; width: 100%;}
.lenta-photo{
	width:150px;
	height:150px;
}

@media (max-width: 768px) {	
	.note-content {
		padding: 0px;
	}
}
</style>
